import { useEffect } from "react";

// Generate or retrieve a stable device id; sent as X-Device-Id header on every API request.
const KEY = "es-device-id";

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `dev_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function useDeviceHeader() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    getDeviceId();
  }, []);
}
